<template>
  <aside
    class="fixed bottom-0 left-0 right-0 z-10 w-full rounded-t-xl bg-white/95 px-6 py-3 shadow-lg backdrop-blur-md md:px-10 md:py-6"
  >
    <slot />
  </aside>
</template>
